export default "<div class=\"gw-checkout-timer gw-fade-in gw-animation-slow ng-animated\" ng-if=$ctrl.enabled> <span class=u-hide@tablet> Holding reservation for </span> <span class=u-show@tablet> We’re holding your reservation for </span> <timer class=gw-checkout-timer__timer interval=1000 end-time=$ctrl.endTime finish-callback=$ctrl.clearTimer() ng-if=$ctrl.endTime> {{ minutes }}:{{ sseconds }} </timer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/common/checkout-timer/checkout-timer.html
// module id = 4Kku
// module chunks = 1